/*
 * rheincool — Rechtsseiten-TOC (Rechtsseiten-Handoff §6)
 * Scrollspy: aktiver Eintrag mit aria-current="true" (nicht nur farbig).
 */
(() => {
  'use strict';
  if (window.__rcLegalToc) return;
  window.__rcLegalToc = true;

  const toc = document.querySelector('[data-legal-toc]');
  if (!toc) return;
  const links = Array.from(toc.querySelectorAll('[data-toc-link]'));
  if (!links.length) return;

  const targets = links
    .map((link) => {
      const el = document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)));
      return el ? { link, el } : null;
    })
    .filter(Boolean);

  const setActive = (active) => {
    targets.forEach(({ link }) => {
      if (link === active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible.length) {
        const match = targets.find(({ el }) => el === visible[0].target);
        if (match) setActive(match.link);
      }
    },
    { rootMargin: '-96px 0px -60% 0px' }
  );
  targets.forEach(({ el }) => observer.observe(el));
})();
